import { apiCall, apiCallAdmin } from "../../services/api-service.js";

export const getDeleteApi = async (deleteUrl) => {
  return await apiCall("DELETE", deleteUrl);
};
export const getDeleteAdminApi = async (deleteUrl) => {
  return await apiCallAdmin("DELETE", deleteUrl);
};

export const bulkDeleteApi = async (deleteUrl, ids) => {
  return await apiCall("DELETE", deleteUrl, { id: ids });
};

export const downloadExcelApi = async (apivalue) => {
  return await apiCall("GET", apivalue);
};

export const uploadExcelApi = async (apivalue, base64String) => {
  const data = {
    file: base64String,
  };
  return await apiCall("POST", apivalue, data);
};

export const downloadTemplateExcelApi = async (mater_type) => {
  const data = {
    type: mater_type,
  };
  return await apiCall("POST", "master_import/template_download", data);
};
